/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

  let minutes = 9;
  let seconds = 59;
  let timerInterval;

  function updateTimer() {
    let minutesDisplay = document.getElementById('minutes');
    let secondsDisplay = document.getElementById('seconds');

    if (minutesDisplay && secondsDisplay) {
      minutesDisplay.textContent = `${minutes.toString().padStart(2, '0')}`;
      secondsDisplay.textContent = `${seconds.toString().padStart(2, '0')}`;
    } else {
      clearInterval(timerInterval);
      let timerElement = document.querySelector('.timer');
      if (timerElement) {
        timerElement.textContent = 'Timer finished!';
      }
      return;
    }

    if (minutes === 0 && seconds === 0) {
      clearInterval(timerInterval);
      document.querySelector('.timer').textContent = 'Timer finished!';
    } else if (seconds === 0) {
      minutes--;
      seconds = 59;
    } else {
      seconds--;
    }
  }

  function startTimer() {
    clearInterval(timerInterval);
    timerInterval = setInterval(updateTimer, 1000); 
  }

  document.addEventListener('cart:updated', function(event) {
   
    startTimer();
  });

  // gclid
  const getGclid = () => {
    if (localStorage.getItem("gclid")) {
      return localStorage.getItem("gclid");
    }

    const urlParams = new URLSearchParams(window.location.search);
    const gclid = urlParams.get('gclid');
  
    if (gclid) {
      localStorage.setItem('gclid', gclid)
      return gclid
    }
  }

  const setGclidValue = () => {
    const gclid = getGclid()
    const gclidInput = document.querySelector('input[name="gclid"]');
    const contactGclidInput = document.querySelector('input[name="contact[gclid]"]');
    
    if (gclid) {
      if (gclidInput) {
        gclidInput.value = gclid
      }

      if (contactGclidInput) {
        contactGclidInput.value = gclid
      }
    }
  }

  setGclidValue()

  // Klick-IDs an die Bestellung haengen (Warenkorb-Attribute, im Admin unter "Zusaetzliche Details").
  // gclid: eigener Speicher mit Zeitstempel, der bestehende "gclid"-Wert fuer die Formulare bleibt unberuehrt.
  // gbraid/wbraid (iOS-Klicks, seit 13.10.2026): gleiche Logik, neueste URL-ID gewinnt, 90 Tage gueltig.
  // Kein eigener Request: die Felder reisen mit dem ohnehin abgeschickten Checkout-Formular (POST /cart).
  ;(() => {
    const MAX_AGE = 90 * 24 * 60 * 60 * 1000;
    const CLICK_IDS = [
      { param: 'gclid', key: 'gclid_order', legacyKey: 'gclid' },
      { param: 'gbraid', key: 'gbraid_order' },
      { param: 'wbraid', key: 'wbraid_order' }
    ];

    try {
      const params = new URLSearchParams(window.location.search);
      CLICK_IDS.forEach(({ param, key }) => {
        const value = params.get(param);
        if (value) localStorage.setItem(key, JSON.stringify({ v: value, t: Date.now() }));
      });
    } catch (e) {}

    const getStoredId = ({ key, legacyKey }) => {
      try {
        const stored = JSON.parse(localStorage.getItem(key) || 'null');
        if (stored && stored.v) {
          return Date.now() - stored.t < MAX_AGE ? stored.v : null;
        }
        return legacyKey ? localStorage.getItem(legacyKey) : null;
      } catch (e) {
        return null;
      }
    };

    const addClickIdsToCheckoutForm = (form) => {
      try {
        if (!form || !form.querySelector('input[name="checkout"]')) return;
        CLICK_IDS.forEach((entry) => {
          const value = getStoredId(entry);
          if (!value) return;
          const name = 'attributes[' + entry.param + ']';
          let input = form.querySelector('input[name="' + name + '"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            form.appendChild(input);
          }
          input.value = value;
        });
      } catch (e) {}
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest('button[name="checkout"]');
      if (button) addClickIdsToCheckoutForm(button.form);
    }, true);

    document.addEventListener('submit', (event) => {
      addClickIdsToCheckoutForm(event.target);
    }, true);
  })();

  // Erweiterte Conversions fuer Anfragen (13.10.2026): Beim Absenden eines Shopify-Kontaktformulars
  // E-Mail und Telefon kurz im Sitzungsspeicher des Tabs ablegen. Die Danke-Seite (page.thankyou.json)
  // uebergibt sie per gtag('set', 'user_data') an Google (gtag hasht sie vor dem Senden) und loescht sie.
  ;(() => {
    const KEY = 'bs_lead_ud';
    const COUNTRY_CODES = { DE: '49', AT: '43', CH: '41' };

    const normalizePhone = (raw) => {
      if (!raw) return null;
      let p = String(raw).trim().replace(/[^\d+]/g, '');
      if (p.indexOf('00') === 0) p = '+' + p.slice(2);
      if (p.charAt(0) !== '+') {
        const cc = COUNTRY_CODES[(window.Shopify && window.Shopify.country) || 'DE'];
        if (!cc || p.charAt(0) !== '0') return null;
        p = '+' + cc + p.replace(/^0+/, '');
      }
      const digits = p.slice(1);
      return /^\d{8,15}$/.test(digits) ? '+' + digits : null;
    };

    document.addEventListener('submit', (event) => {
      try {
        const form = event.target;
        if (!form || !form.querySelector) return;
        const formType = form.querySelector('input[name="form_type"]');
        if (!formType || formType.value !== 'contact') return;
        const emailInput = form.querySelector('input[name="contact[email]"]');
        const email = emailInput ? emailInput.value.trim().toLowerCase() : '';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
        const data = { email: email, t: Date.now() };
        const phoneInput = form.querySelector('input[name="contact[Telefon]"], input[type="tel"]');
        const phone = phoneInput ? normalizePhone(phoneInput.value) : null;
        if (phone) data.phone_number = phone;
        sessionStorage.setItem(KEY, JSON.stringify(data));
      } catch (e) {}
    }, true);
  })();
